import { withStyles } from '@material-ui/core';
import { Header, Table, Summary } from '../components';

const styles = (_theme) => ({
  hideContainer: {
    display: 'none'
  },
  pageBreak: {
    pageBreakBefore: 'always'
  },
  '@media print': {
    pageBreakFirst: {
      pageBreakBefore: 'auto'
    }
  }
});

const Container = ({ classes, printRef, printData }) => {
  return (
    <div className={classes.hideContainer}>
      <div ref={printRef}>
        {printData.map((route, routeIndex) => (
          <React.Fragment key={routeIndex}>
            <div
              className={`${classes.pageBreak} ${routeIndex === 0 ? classes.pageBreakFirst : ''}`}
            />
            <Header headerData={route.header} key={routeIndex} />
            <Table tableData={route.table} />
            <Summary summaryData={route.summary} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default withStyles(styles)(Container);
